import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const GerarPDF = (Alunos, content) => {
  pdfMake.vfs = {
    "Roboto-Italic.ttf": pdfFonts["Roboto-Italic.ttf"],
    "Roboto-Medium.ttf": pdfFonts["Roboto-Medium.ttf"],
    "Roboto-MediumItalic.ttf": pdfFonts["Roboto-MediumItalic.ttf"],
    "Roboto-Regular.ttf": pdfFonts["Roboto-Regular.ttf"],
  };

  // Verifica se o vfs foi corretamente atribuído
  if (!pdfMake.vfs) {
    // console.log("pdf.vfs: ", pdfMake.vfs);
    console.error("Erro: vfs não foi definido corretamente");
    return;
  }

  const tituloRelatorio = [
    {
      text: content.titulo,
      width: 500,
      color: "red",
      fontSize: 15,
      bold: true,
      alignment: "center",
      margin: [15, 20, 0, 45], // left, top, right, bottom
    },
  ];

  const dados = Alunos.map((aluno) => {
    const cumpriu = aluno.cumpriu === 1 ? "Sim" : aluno.cumpriu === 0 ? "Não" : "Não Avaliado";
    const conceito = aluno.conceito || "Não Avaliado";

    return [
      { text: aluno.rm, fontSize: 10, margin: [0, 2, 2, 0], color: "black", alignment: "center" },
      { text: aluno.nome_aluno, fontSize: 10, margin: [0, 2, 2, 0], color: "black", alignment: "left" },
      { text: cumpriu, fontSize: 10, margin: [0, 2, 2, 0], color: "black", alignment: "center" },
      { text: conceito, fontSize: 10, margin: [0, 2, 2, 0], color: "black", alignment: "center" },
    ];
  });

  const estilosHeader = {
    tableHeader: {
      fontSize: 12,
      bold: true,
      fillColor: "gray",
      color: "#FFFFFF",
      alignment: "center",
    },
  };

  const turma = content?.turma?.split("-")?.slice(1)?.join(" - ");
  const turma_resumo = turma?.includes("CURSO") ? turma?.replace("CURSO", "") : turma;

  const Conteudo = [
    { text: `Curso: ${content?.curso}`, alignment: "start", margin: [0, 5, 0, 0] },
    {
      text: `Turma: ${turma_resumo?.trim()}`,
      alignment: "start",
      margin: [0, 5, 0, 0],
    },
    { text: `Disciplina: ${content?.disciplina}`, alignment: "start", margin: [0, 5, 0, 0] },
    { text: `Professor(a): ${content?.professor}`, alignment: "start", margin: [0, 5, 5, 0] },
    {
      columns: [
        { text: `Início: ${content?.DataInicio}`, alignment: "start" },
        { text: `Término: ${content?.DataFim}`, alignment: "right" },
      ],
      fontSize: 12,
      margin: [10, 20, 10, 5],
    },
    {
      style: "tableExample",
      table: {
        headerRows: 1,
        widths: ["*", 250, "*", "*"],
        body: [
          [
            { text: "RM", style: "tableHeader" },
            { text: "Nome", style: "tableHeader" },
            { text: "Cumpriu", style: "tableHeader" },
            { text: "Conceito", style: "tableHeader" },
          ],
          ...dados,
        ],
      },
      layout: {
        fillColor: function (rowIndex) {
          return rowIndex % 2 === 0 ? "#dddddd" : "#f3f3f3";
        },
      },
    },
  ];

  function rodape(currentPage, pageCount) {
    return [
      {
        columns: [{ text: currentPage + " / " + pageCount, alignment: "center" }],
        fontSize: 9,
        margin: [20, 0, 20, 0],
        columnGap: 10,
      },
    ];
  }

  const definicaoDocumento = {
    pageSize: "A4",
    pageMargins: [15, 50, 15, 40],
    header: tituloRelatorio,
    content: Conteudo,
    footer: rodape,
    styles: estilosHeader,
  };

  const namePdf = `${content.titulo.toUpperCase()} - ${content.turma.split(" - ")[0]} - ${content.disciplina}.pdf`;

  pdfMake.createPdf(definicaoDocumento).download(namePdf);
};

export default GerarPDF;
